import React from "react";
import type { SVGProps } from "react";
const SvgPhotos = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 235 165" {...props}>
    <circle cx={135.5} cy={106.5} r={58.5} fill="#4F45E4" opacity={0.2} />
    <circle cx={174} cy={53} r={13} fill="url(#a)" fillOpacity={0.6} />
    <circle cx={106.5} cy={75.5} r={31.5} fill="#4F45E4" fillOpacity={0.3} />
    <circle cx={50} cy={76} r={49} fill="url(#b)" opacity={0.4} />
    <g filter="url(#c)">
      <path
        fill="url(#d)"
        d="M16 80a9 9 0 0 1 9-9h189a9 9 0 0 1 9 9v30a9 9 0 0 1-9 9H25a9 9 0 0 1-9-9z"
      />
      <path
        stroke="#374151"
        strokeWidth={2}
        d="M17 80a8 8 0 0 1 8-8h189a8 8 0 0 1 8 8v30a8 8 0 0 1-8 8H25a8 8 0 0 1-8-8z"
      />
    </g>
    <path
      fill="#F9FAFB"
      d="M69.292 101V87.91h8.821v2.281H72.06v3.12h5.6v2.281h-5.6v3.126h6.079V101zm14.588.16a3.7 3.7 0 0 1-2.026-.575q-.9-.582-1.432-1.707-.524-1.132-.524-2.774 0-1.687.543-2.806.544-1.125 1.445-1.681a3.7 3.7 0 0 1 1.988-.563q.825 0 1.374.281.557.276.895.69a3.5 3.5 0 0 1 .524.806h.083v-4.922h2.717V101h-2.685v-1.572h-.115a3.5 3.5 0 0 1-.543.811q-.345.397-.901.659-.55.262-1.343.262m.863-2.167q.66 0 1.113-.358.459-.365.703-1.016.249-.652.249-1.528t-.243-1.521-.703-.998-1.119-.351q-.67 0-1.131.364-.461.365-.697 1.01-.237.646-.236 1.496 0 .856.236 1.515.243.651.697 1.023.46.363 1.131.364M91.706 101v-9.818h2.723V101zm1.368-11.084a1.48 1.48 0 0 1-1.042-.403 1.3 1.3 0 0 1-.428-.978q0-.561.428-.965.435-.409 1.042-.409t1.035.41q.435.402.435.965 0 .569-.435.977-.427.403-1.035.403m8.758 1.266v2.045H95.92v-2.045zm-4.57-2.353h2.723v9.154q0 .376.115.588a.63.63 0 0 0 .32.288q.21.083.486.083.19 0 .383-.032l.294-.058.428 2.027a8 8 0 0 1-.575.147 4.7 4.7 0 0 1-.901.108q-.985.038-1.726-.262-.735-.3-1.144-.933-.41-.633-.403-1.598zm13.329-.92V101h-2.768V87.91zM112.817 101v-9.818h2.595v1.732h.115a2.73 2.73 0 0 1 1.023-1.361q.716-.5 1.713-.499 1.01 0 1.72.505.71.498.946 1.355h.102q.3-.843 1.087-1.349.792-.51 1.872-.511 1.375 0 2.231.876.863.87.863 2.467V101h-2.716v-6.066q0-.819-.435-1.227-.435-.41-1.087-.41-.741 0-1.157.474-.415.466-.415 1.233V101h-2.64v-6.124q0-.722-.416-1.15-.408-.428-1.08-.428-.453 0-.818.23a1.6 1.6 0 0 0-.569.632 2 2 0 0 0-.211.947V101zm19.218.185q-.94 0-1.675-.326a2.7 2.7 0 0 1-1.163-.978q-.422-.651-.422-1.623 0-.819.3-1.374a2.44 2.44 0 0 1 .818-.895 4 4 0 0 1 1.177-.512 9 9 0 0 1 1.393-.243q.856-.09 1.381-.166.524-.082.76-.243a.53.53 0 0 0 .237-.473v-.038q0-.607-.384-.94-.377-.332-1.073-.332-.736 0-1.17.326-.435.32-.576.805l-2.518-.204a3.4 3.4 0 0 1 .754-1.547 3.6 3.6 0 0 1 1.451-1.01q.895-.358 2.071-.358.819 0 1.566.192a4.1 4.1 0 0 1 1.336.594q.588.403.927 1.036.339.626.339 1.502V101h-2.582v-1.362h-.077a2.8 2.8 0 0 1-.633.812q-.397.346-.952.544a4 4 0 0 1-1.285.191m.78-1.879q.6 0 1.061-.236a1.9 1.9 0 0 0 .722-.652q.262-.41.262-.927v-1.042a1.5 1.5 0 0 1-.351.153 6 6 0 0 1-.493.122q-.274.051-.549.096l-.499.07q-.48.07-.837.224-.358.153-.556.415-.2.256-.199.64 0 .555.403.85.41.287 1.036.287m11.285 5.58q-1.324 0-2.269-.364-.94-.359-1.496-.978a3 3 0 0 1-.722-1.393l2.518-.339q.115.294.364.55.25.255.659.409.415.159 1.01.159.888 0 1.463-.434.582-.429.582-1.438v-1.797h-.115q-.178.409-.537.774a2.7 2.7 0 0 1-.92.594q-.563.23-1.343.23-1.105 0-2.013-.511-.901-.517-1.438-1.579-.531-1.067-.531-2.697 0-1.668.543-2.787.544-1.119 1.445-1.675a3.73 3.73 0 0 1 1.988-.556q.825 0 1.381.281.556.276.895.69.345.41.53.806h.102v-1.65h2.704v9.915q0 1.253-.613 2.096-.614.844-1.701 1.266-1.08.428-2.486.428m.057-6.072q.659 0 1.113-.326.46-.333.703-.946.249-.62.249-1.483t-.243-1.496q-.243-.639-.703-.99-.46-.352-1.119-.352-.67 0-1.131.364-.46.358-.697.997-.236.64-.236 1.477 0 .85.236 1.47.243.614.697.953.46.332 1.131.332m11.385 2.378q-1.516 0-2.608-.614a4.2 4.2 0 0 1-1.675-1.751q-.588-1.139-.588-2.691 0-1.515.588-2.66a4.35 4.35 0 0 1 1.655-1.783q1.074-.639 2.519-.639a5.1 5.1 0 0 1 1.809.313 4 4 0 0 1 1.47.927q.633.62.984 1.56.352.932.352 2.186v.748h-8.291V95.1h5.728q0-.588-.256-1.042a1.83 1.83 0 0 0-.709-.71 2.03 2.03 0 0 0-1.042-.261q-.62 0-1.1.287a2 2 0 0 0-.741.76 2.15 2.15 0 0 0-.275 1.056v1.604q0 .729.268 1.26.275.53.774.817.498.288 1.182.288.454 0 .831-.128a1.7 1.7 0 0 0 .646-.383q.268-.256.409-.627l2.518.166a3.43 3.43 0 0 1-.786 1.586q-.588.671-1.521 1.048-.927.37-2.141.371m14.452-7.21-2.493.153a1.3 1.3 0 0 0-.275-.575 1.45 1.45 0 0 0-.556-.416 1.9 1.9 0 0 0-.812-.16q-.632 0-1.067.269-.435.262-.435.703 0 .351.281.594t.966.39l1.777.358q1.431.294 2.135.946.703.653.703 1.713 0 .966-.569 1.694-.563.729-1.547 1.138-.978.403-2.256.403-1.95 0-3.107-.812-1.15-.818-1.349-2.224l2.679-.141q.121.594.588.908.466.306 1.195.306.716 0 1.15-.275.442-.28.448-.722a.75.75 0 0 0-.313-.607q-.307-.243-.946-.37l-1.701-.34q-1.437-.287-2.141-.997-.697-.71-.697-1.809 0-.945.512-1.63.518-.684 1.451-1.054.939-.37 2.199-.371 1.86 0 2.927.786 1.074.786 1.253 2.141"
    />
    <g
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      clipPath="url(#e)">
      <path d="M211.684 105.901a10.367 10.367 0 0 1-6.71 13.035M205.562 103.78l-.396-1.234a2.59 2.59 0 0 0-3.258-1.677 2.59 2.59 0 0 0-1.678 3.259" />
      <path d="m200.23 104.128-.395-1.234a2.594 2.594 0 0 0-3.259-1.677 2.587 2.587 0 0 0-1.677 3.258l.395 1.234" />
      <path d="m195.096 105.092-2.174-6.787a2.593 2.593 0 0 0-4.773-.395 2.6 2.6 0 0 0-.163 1.977l3.953 12.34" />
      <path d="M205.561 103.781a2.594 2.594 0 0 1 4.937-1.582l1.186 3.702a10.367 10.367 0 0 1-6.71 13.035l-2.468.791c-3.455 1.107-5.893.718-8.317-.519l-5.865-3.019a2.594 2.594 0 0 1 2.377-4.599l2.868 1.476" />
    </g>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={2}
      d="M191.865 90.747 190 84M198.339 91.65l4.826-5.063"
    />
    <path
      fill="#1F2937"
      d="M69 7a7 7 0 0 1 7-7h35a7 7 0 0 1 7 7v22a7 7 0 0 1-7 7h-7l-6.25 11.5L91.5 36H76a7 7 0 0 1-7-7z"
    />
    <path
      stroke="#F9FAFB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M87.25 13.5h13.5M99.25 13.5V24c0 .75-.75 1.5-1.5 1.5h-7.5c-.75 0-1.5-.75-1.5-1.5V13.5M91 13.5V12c0-.75.75-1.5 1.5-1.5h3c.75 0 1.5.75 1.5 1.5v1.5M92.5 17.25v4.5M95.5 17.25v4.5"
    />
    <g filter="url(#f)">
      <path
        fill="#111827"
        d="M128 19a7 7 0 0 1 7-7h35a7 7 0 0 1 7 7v22a7 7 0 0 1-7 7h-7l-6.25 11.5L150.5 48H135a7 7 0 0 1-7-7z"
      />
      <path
        stroke="#374151"
        strokeWidth={2}
        d="M163 47h-.595l-.284.523-5.371 9.883-5.371-9.883-.284-.523H135a6 6 0 0 1-6-6V19a6 6 0 0 1 6-6h35a6 6 0 0 1 6 6v22a6 6 0 0 1-6 6z"
      />
    </g>
    <g
      stroke="#F9FAFB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      clipPath="url(#g)">
      <path d="M148 21.667v11.666A1.67 1.67 0 0 0 149.667 35h11.666" />
      <path d="M158 38.333V26.667A1.67 1.67 0 0 0 156.333 25h-11.666" />
    </g>
    <g strokeWidth={2} filter="url(#h)">
      <path
        fill="#111827"
        stroke="#374151"
        d="M75.5 53h-.595l-.284.523-5.371 9.883-5.371-9.883-.284-.523H56a6 6 0 0 1-6-6V25a6 6 0 0 1 6-6h35a6 6 0 0 1 6 6v22a6 6 0 0 1-6 6z"
      />
      <path
        stroke="#F9FAFB"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M81.5 36v5.833a1.666 1.666 0 0 1-1.667 1.667H68.167a1.666 1.666 0 0 1-1.667-1.667V30.167a1.666 1.666 0 0 1 1.667-1.667H74M77.333 30.167h5M79.833 27.667v5"
      />
      <path
        stroke="#F9FAFB"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M71.5 35.167a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334M81.5 38.5l-2.572-2.572a1.667 1.667 0 0 0-2.356 0L69 43.5"
      />
    </g>
    <defs>
      <linearGradient id="a" x1={174} x2={174} y1={40} y2={66} gradientUnits="userSpaceOnUse">
        <stop stopColor="#9A45E4" />
        <stop offset={1} stopColor="#55267E" />
      </linearGradient>
      <linearGradient id="b" x1={50} x2={50} y1={27} y2={125} gradientUnits="userSpaceOnUse">
        <stop stopColor="#0D9488" stopOpacity={0.75} />
        <stop offset={1} stopColor="#042E2A" stopOpacity={0.75} />
      </linearGradient>
      <linearGradient id="d" x1={120} x2={123} y1={71} y2={122} gradientUnits="userSpaceOnUse">
        <stop stopColor="#111827" />
        <stop offset={1} stopColor="#131832" />
      </linearGradient>
      <filter
        id="c"
        width={239}
        height={80}
        x={0}
        y={59}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={8} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
      </filter>
      <filter
        id="f"
        width={57}
        height={55.5}
        x={124}
        y={12}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
      </filter>
      <filter
        id="h"
        width={57}
        height={56}
        x={45}
        y={18}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
      </filter>
      <clipPath id="e">
        <path fill="#fff" d="m179 97.323 29.617-9.49 9.489 29.618-29.617 9.489z" />
      </clipPath>
      <clipPath id="g">
        <path fill="#fff" d="M143 20h20v20h-20z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPhotos;
